import React, { useEffect, useState } from 'react';
import { ResponsiveRender } from '@pb/shared/ui/atoms/responsive-render';
import { StyledUl } from '../../templates/index-page';
import { ThreadList } from '../../atoms/thread-list/thread-list';
import { NoMessagesNotification } from '../../atoms/no-messages-notification';
import { LoadingNotification } from '../../atoms/loading-notification/loading-notification';
import { sortThreads } from '../../../helpers';
import { TThread } from '../../../configuration/common.types';
import { TThreadsViewComponentProperties } from './threads-view.types';
import { StyledNoThreadsContainer } from './threads-view.styled';

export const ThreadsView = ({
    threadId,
    threads,
    user,
}: TThreadsViewComponentProperties) => {
    const { data, hasNextPage, isFetchingNextPage, fetchNextPage } = threads;
    const [gotAllPages, setGotAllPages] = useState(false);

    useEffect(() => {
        const fetchAllPages = async () => {
            // Keep fetching next pages as long as there are more pages and we're not already fetching
            if (
                hasNextPage !== undefined &&
                hasNextPage &&
                !isFetchingNextPage
            ) {
                await fetchNextPage();
            }
        };

        // Only start fetching all pages once the initial data is loaded
        if (data && hasNextPage && !isFetchingNextPage) {
            fetchAllPages();
        }

        if (hasNextPage !== undefined && !hasNextPage) {
            setGotAllPages(true);
        }
    }, [data, hasNextPage, isFetchingNextPage, fetchNextPage]);

    if (threads.isLoading || !gotAllPages) {
        return <LoadingNotification />;
    }

    const flatThreads = threads.data.pages.flatMap(page => page.threads);

    const sortedThreads = sortThreads(flatThreads);

    return (
        <div>
            <StyledUl>
                {user?.data ? (
                    <div>
                        {sortedThreads.map((thread: TThread) => (
                            <ThreadList
                                key={thread.id}
                                user={user.data}
                                thread={thread}
                                currentThreadId={threadId}
                            />
                        ))}
                    </div>
                ) : (
                    <ResponsiveRender showOnBreakpoints={['xs', 's']}>
                        <StyledNoThreadsContainer>
                            <NoMessagesNotification />
                        </StyledNoThreadsContainer>
                    </ResponsiveRender>
                )}
            </StyledUl>
        </div>
    );
};
